<template>
  <v-card class="ma-2">
    <v-card-title
      v-if="showTitle"
      class="pa-0 subheading"
      :class="titleClass"
    >
      <v-btn
        v-if="!hideActivator && !icon"
        icon
        :disabled="disableActivator"
        @click="toggleActive"
      >
        <v-icon>{{ isActive ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
      <v-icon
        v-else-if="icon"
        class="ma-2 mr-3"
      >
        {{ icon }}
      </v-icon>
      <slot name="title" />
      <v-spacer />
      <slot name="title-right" />
    </v-card-title>
    <v-divider />
    <template v-if="expandTransition">
      <v-expand-transition>
        <v-card-text
          v-if="isActive"
          class="pa-0"
        >
          <slot />
        </v-card-text>
        <v-card-actions v-if="showActions">
          <slot name="actions" />
        </v-card-actions>
      </v-expand-transition>
    </template>
    <template v-else>
      <v-fade-transition>
        <v-card-text
          v-if="isActive"
          class="pa-0"
        >
          <slot />
        </v-card-text>
        <v-card-actions v-if="showActions">
          <slot name="actions" />
        </v-card-actions>
      </v-fade-transition>
    </template>
  </v-card>
</template>

<script>
export default {
  name: 'ExpansionCard',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    errors: Array,
    icon: String,
    hideActivator: Boolean,
    disableActivator: Boolean,
    expandTransition: Boolean,
  },
  data: () => ({
    isActive: false
  }),
  computed: {
    hasErrors () {
      return this.errors && !!this.errors._hasErrors
    },
    titleClass () {
      const classes = {}
      if (this.hasErrors) {
        classes[this.$ftAppIsDark ? this.$ftStyle.dark.sectionTitleError : this.$ftStyle.light.sectionTitleError] = true
      } else {
        classes[(this.$ftAppIsDark ? this.$ftStyle.dark.sectionTitle : this.$ftStyle.light.sectionTitle) + ' test'] = true
      }
      return classes
    },
    showActions () {
      return this.$slots.actions && this.$slots.actions[0]
    },
    showTitle () {
      return this.$slots.title && this.$slots.title[0]
    }
  },
  watch: {
    value () {
      if (this.isActive !== this.value) this.isActive = this.value
    },
    isActive () {
      this.$emit('input', this.isActive)
    }
  },
  mounted () {
    this.isActive = this.value
    console.log('Vuetify', this.$vuetify)
  },
  methods: {
    toggleActive () {
      if (this.disableActivator) return
      this.isActive = !this.isActive
    }
  }
}
</script>
